import { makeActionCreator } from '../../../core/types/redux';
import {
  ResultPreviewActionConstants as C,
  RequestResultPreviewArgs,
  SetResultPreviewArgs,
  RequestAttachPreviewArgs,
  SetAttachPreviewArgs,
} from './types';

const create = makeActionCreator<C>();

export const initialize = create(C.INITIALIZE);
export const requestResultPreview = create<RequestResultPreviewArgs>(C.RESULT_PREVIEW_REQUEST);
export const setResultPreview = create<SetResultPreviewArgs>(C.RESULT_PREVIEW_SET);
export const requestAttachPreview = create<RequestAttachPreviewArgs>(C.ATTACH_PREVIEW_REQUEST);
export const setAttachPreview = create<SetAttachPreviewArgs>(C.ATTACH_PREVIEW_SET);
